import getPublicUrl from '@/helpers/utils/routing/getPublicUrl'
import { PageProps } from '@/types'
import { toPathFactory } from '@/helpers/utils/routing/toPathFactories'
export const pageUrl = '/[locale]/fundraising-events/[slug]/thank-you?ids'
export const getPageUrl = toPathFactory(pageUrl, getPublicUrl)
export type ThankYouModalPageProps = PageProps<typeof pageUrl, { ids?: string[] }>
